module.exports = __webpack_public_path__ + "img/new_06_1.54f0c09e.jpg";